import {Youtube} from 'vue-youtube';

export default {
  data() {
    return {
      videoId: this.$route.params.videoId,
      playerVars: {
        controls: 1,
        showinfo: 1,
        loop: 1,
        autoplay: 0,
        enablejsapi: 1
      }
    }
  },
  mounted() {
    alert('OK here you go...')
    this.$store.dispatch('section/filter', currentPage.slug);
  },
  methods: {
    playVideo() {
      this.player.playVideo()
    },
    playing() {
      console.log('\o/ we are watching!!!')
    },
  },
  components: {
    Youtube,
  },
  computed: {
    fetchCurrentVideo() {
      let videoId = this.$route.params.videoId;

      if (this.videosBySection) {
        return _.filter(this.videosBySection.settings.fields, function (o) {
          return o.id == videoId;
        });
      }

      return [];
    },
    videosBySection() {
      return this.$store.getters['section/findBlockById'](this.$route.params.sectionId, this.$route.params.blockId);
    },
    player() {
      return this.$refs.youtube.player
    },
    getVideoId() {
      return this.$route.params.videoId;
    }
  }
}